import * as StageStatus from '../stageStatus/index';
import Utils from '../utils/util';

interface LogParams {
    action: string,
    msgList: Array<FreeObjMap>
};

function log(params: LogParams): void {
    if (!StageStatus.showLog()) {
        return;
    }

    console.group(`%c🕷 %caction %c${params.action} %c@${Utils.getDate()}`, 'font-size: 14px;', 'font-size: 10px; color: #808080;', 'font-size: 12px; color: #000;', 'font-size: 10px; color: #808080;');
    params.msgList.forEach((msg: FreeObjMap) => {
        if (Utils.hasKey(msg, 'name')) {
            console.log(`%c${msg.name}`, 'font-size: 10px; color: #4eaaec;', Utils.deepCopy(msg.value));
            return;
        }
        console.log(`%c${Utils.deepCopy(msg.value)}`, 'font-size: 10px; color: #4eaaec;');
    });
    console.groupEnd();
}

export {
    log
};
